import { AuthService } from '@/services/auth.service';
import { runtimeCapabilities } from '@/config/runtimeCapabilities';

export const checkAuthOrRedirect = (deviceSerial?: string) => {
  if (runtimeCapabilities.singleDevice) {
    const pathname = window.location.pathname;
    const isOfflineLandingRoute =
      pathname === '/' ||
      pathname === '/app' ||
      pathname === '/app/' ||
      pathname === '/app/devices' ||
      pathname === '/app/devices/' ||
      pathname === '/auth' ||
      pathname.startsWith('/auth/');

    if (deviceSerial && isOfflineLandingRoute) {
      window.location.replace(`/app/devices/${deviceSerial}/`);
    }

    return null;
  }

  const isRouteRequiresAuth = window.location.pathname.startsWith('/app');
  const isRouteRequiresGuest = window.location.pathname.startsWith('/auth');

  const isUserAuthenticated = AuthService.isAuthenticated();

  if (isRouteRequiresAuth) {
    if (!isUserAuthenticated) {
      const referer = encodeURIComponent(window.location.href);
      window.location.replace(`/auth/login?referer=${referer}`);
      return null;
    }
  }
  if (isRouteRequiresGuest) {
    if (isUserAuthenticated) {
      window.location.replace('/app');
      return null;
    }
  }
};
